import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	stroke: "#B6B6B6",
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.7513 7.99967C10.5923 7.99967 12.0846 6.50729 12.0846 4.66634C12.0846 2.82539 10.5923 1.33301 8.7513 1.33301C6.91035 1.33301 5.41797 2.82539 5.41797 4.66634C5.41797 6.50729 6.91035 7.99967 8.7513 7.99967Z",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.4768 14.6667C14.4768 12.0867 11.9101 10 8.7501 10C5.5901 10 3.02344 12.0867 3.02344 14.6667",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUser;
